import Extend from 'flarum/common/extenders';
import app from 'flarum/forum/app';
import commonExtend from '../common/extend';
import SpeciesCorrectionsPage from './components/SpeciesCorrectionsPage';
import SpeciesPage from './components/SpeciesPage';
import TaxonPage from './components/TaxonPage';
import DescriptionsPage from './components/DescriptionsPage';
import DescriptionPage from './components/DescriptionPage';
import MissingSpeciesPage from './components/MissingSpeciesPage';
import speciesSlug from './utils/speciesSlug';
export default [...commonExtend, new Extend.Routes().add('speciesCorrections', '/species-corrections', SpeciesCorrectionsPage),
// /species/:id/:slug is the pretty, canonical form (app.route.species(id,
// canonicalName) below builds it) - :slug is never read by SpeciesPage.js
// itself (only :id fetches data), so it's purely cosmetic and never needs
// validating or redirecting against. 'species.legacy' keeps the old bare
// /species/:id form resolving to the exact same page, so links shared
// before this change keep working - Mithril matches routes by segment
// count, so the two patterns never conflict.
new Extend.Routes().add('species', '/species/:id/:slug', SpeciesPage).add('species.legacy', '/species/:id', SpeciesPage).helper('species', (id, canonicalName) => app.route('species', {
  id,
  slug: speciesSlug(canonicalName)
})),
// Same pretty-URL + legacy-fallback split as 'species'/'species.legacy'
// above - see TaxonPage's own docblock for what this route is and how a
// visitor actually ends up on it.
new Extend.Routes().add('taxon', '/taxon/:id/:slug', TaxonPage).add('taxon.legacy', '/taxon/:id', TaxonPage).helper('taxon', (id, canonicalName) => app.route('taxon', {
  id,
  slug: speciesSlug(canonicalName)
})), new Extend.Routes().add('descriptions', '/descriptions', DescriptionsPage),
// Same pretty-URL + legacy-fallback split as 'species'/'species.legacy'
// above, slugged from the description's own species name (canonicalName,
// not the discussion's own title - DescriptionPage.js's slug is about the
// species it's a write-up of).
new Extend.Routes().add('description', '/description/:id/:slug', DescriptionPage).add('description.legacy', '/description/:id', DescriptionPage).helper('description', (id, canonicalName) => app.route('description', {
  id,
  slug: speciesSlug(canonicalName)
})), new Extend.Routes().add('missingSpecies', '/missing-species', MissingSpeciesPage)];